namespace GeniuzPOS.QRreport {
    export interface QRyStockcardRow {
        Id?: number;
        DateEnd?: string;
        PostSequenceFg?: number;
        SumWhsFg?: number;
        WhsFg?: number;
        WhsId?: string;
        ShopId?: string;
        ListFg?: number;
        SkuCode?: string;
        PluCode?: string;
        CreateBy?: string;
    }

    export namespace QRyStockcardRow {
        export const idProperty = 'Id';
        export const nameProperty = 'WhsId';
        export const localTextPrefix = 'QRreport.QRyStockcard';
        export const lookupKey = 'QRreport.QRyStockcard';

        export function getLookup(): Q.Lookup<QRyStockcardRow> {
            return Q.getLookup<QRyStockcardRow>('QRreport.QRyStockcard');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            DateEnd = "DateEnd",
            PostSequenceFg = "PostSequenceFg",
            SumWhsFg = "SumWhsFg",
            WhsFg = "WhsFg",
            WhsId = "WhsId",
            ShopId = "ShopId",
            ListFg = "ListFg",
            SkuCode = "SkuCode",
            PluCode = "PluCode",
            CreateBy = "CreateBy"
        }
    }
}
